<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" fill="none" viewBox="0 0 15 10"><path fill="#fff" d="m13.019.586-8.061 8.06a.583.583 0 0 1-.827 0l-3.117-3.12a.583.583 0 1 0-.827.827L3.306 9.47a1.755 1.755 0 0 0 2.479 0l8.06-8.058a.584.584 0 1 0-.826-.826Z"/></svg>
</template>

<script>
export default {
  name: "IconConfiguratorCheck"
}
</script>
 